<template>
  <v-alert
    v-if="isVisible"
    class="maintenance-banner"
    color="amber darken-1"
    dark
    dense
    icon="mdi-alert-circle-outline"
    dismissible
    @input="onDismiss"
  >
    <div class="d-flex align-center justify-space-between">
      <div class="banner-content">
        <v-icon class="mr-2" small>mdi-wrench</v-icon>
        <span class="banner-message">{{ message }}</span>
      </div>
    </div>
  </v-alert>
</template>

<script>
import bannerConfig from '@/config/banner.json';

export default {
  name: 'MaintenanceBanner',
  data() {
    return {
      isDismissed: false,
      isActive: bannerConfig.isActive,
      message: bannerConfig.message
    };
  },
  computed: {
    isVisible() {
      return this.isActive && !this.isDismissed;
    }
  },
  methods: {
    onDismiss() {
      this.isDismissed = true;
    }
  }
};
</script>

<style scoped>
.maintenance-banner {
  margin: 0;
  border-radius: 0;
  position: relative;
  z-index: 1000;
}

.maintenance-banner >>> .v-alert__wrapper {
  max-width: 100%;
}

.banner-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.banner-message {
  font-weight: 500;
  letter-spacing: 0.02em;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .banner-message {
    font-size: 0.875rem;
  }
  
  .maintenance-banner {
    padding: 8px 12px;
  }
}
</style>

